export default __webpack_public_path__ + "static/media/7748113c6a274f93340364a1e917b72f.png";